/**
 * 防劫持重写document.write
 * 
 * 改写了全局document.write, 可以设置域名白名单，如果通过document.write方式插入script标签，则只能插入白名单里指定的域名。
 * 模块暴露出来的write方法可以正常使用document.write的功能
 * 
 * ```
 * var docWrite = require('document_write');
 * 
 * docWrite.config({
 *     whiteLists: [
 *         'img.jiuwo.kanimg.com',
 *     ]
 * });
 * 
 * // 正常插入脚本
 * document.write("<script language='javascript' src='http://img.jiuwo.kanimg.com/web/dist/jiuwo/2.0.3/source/xl9/tab_html/js/jiuwo.js?v=1467975536871&_veri=20151101'><\/script>");
 * 
 * // 域名不在白名单，不能插入脚本
 * document.write("<script language='javascript' src='http://er.daapin.com/lib/query?src=t6409&t="+encodeURIComponent(document.title)+"&r="+encodeURIComponent(document.referrer)+"&ci=1903443296'><\/script>");
 *　
 * // docWrite是采用原来的document.write，不受影响
 * docWrite("<script language='javascript' src='http://er.daapin.com/lib/query?src=t6409&t="+encodeURIComponent(document.title)+"&r="+encodeURIComponent(document.referrer)+"&ci=1903443296'><\/script>");
 * ```
 */
var docWrite = document.write;
var scriptPattern = /<script.*?src\=["']?([^"'\s>]+)/ig;
var domainPattern = /(.+?)\/([^\/]+).+/;
var _config = {
    whiteLists: []
};


var write = function (str) {
    if (docWrite.apply) {
        docWrite.apply(document, arguments);
    } else {
        docWrite(str);
    }
}

/**
 * @method config
 * @param obj {object} 配置参数
 */
write.config = function (obj) {
    for (var i in obj) {
        _config[i] = obj[i];
    }
}

/**
 * @method　document.write
 * @param str {string}
 */
document.write = function (str) {
    var scripts = scriptPattern.exec(str);
    if (scripts) {
        try {
            var url = scripts[1];
            var domain = domainPattern.exec(url)[2];
    
            if (_config.whiteLists.indexOf(domain) !== -1) {
                write(str);
            }
        } catch (e) {
        }
    }
}



module.exports = write;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/document_write.js
// module id = 6
// module chunks = 1 2 3 5 6 7 8 9 10 11 12